export const FETCH_CHART_BOARD = "app/ChartBoard/FETCH";
export const FETCH_CHART_BOARD_SUCCESS = "app/ChartBoard/FETCH_SUCCESS";
export const FETCH_CHART_BOARD_FAILURE = "app/ChartBoard/FETCH_FAILURE";
